import React from "react";
import { Grid, Divider, CircularProgress } from "@material-ui/core";

import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { html2json, json2html } from "html2json";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { useForm, Controller, useWatch } from "react-hook-form";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { useAlert } from "../../components/Alert";
import { Card, CardContent, CardActions } from "../../components/Card";
import Button from "../../components/Button";
import Text from "../../components/Text";
import LoadingModal from "../../components/LoadingModal";
import DraftWysiwyg from "./DraftWysiwyg";

const GET_EXCLUSIVEWEB = gql`
  query exclusiveWeb($id: Int!) {
    exclusiveWeb(id: $id) {
      id
      aboutUs {
        id
        content
      }
    }
  }
`;

const SAVE_ABOUTUS = gql`
  mutation saveAboutUs($id: Int, $content: String!) {
    saveAboutUs(id: $id, content: $content)
  }
`;

export default function AboutUsForm({ id }) {
  const Alert = useAlert();
  const { handleSubmit, control, setValue, getValues } = useForm({
    defaultValues: {
      editorState: EditorState.createEmpty(),
      image: null,
    },
  });

  const htmlFormat = (data) => {
    const json = html2json(data);
    Array.isArray(json.child) &&
      json.child.forEach((item) => {
        if (item.tag === "div") {
          item.tag = "img";
          if (
            item.attr &&
            Array.isArray(item.child) &&
            item.child.length === 1 &&
            item.child[0].attr &&
            Array.isArray(item.child[0].attr.style)
          ) {
            const style = item.attr.style + item.child[0].attr.style.join("");
            item.attr = {
              ...item.child[0].attr,
            };
            item.attr.style = style;
          }
        }
      });
    const html = json2html(json);

    return html;
  };

  const editorState = useWatch({ control, name: "editorState" });
  const { loading } = useQuery(GET_EXCLUSIVEWEB, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      id,
    },
    onCompleted({ exclusiveWeb }) {
      let newContent;
      let contentState;
      if (exclusiveWeb?.aboutUs) {
        newContent = htmlFormat(
          exclusiveWeb.aboutUs.content.replace(
            /<div style="text-align:center;"><img/g,
            '<div style="text-align:none;"><img'
          )
        );
        const contentBlock = htmlToDraft(newContent, (nodeName, node) => {
          if (nodeName === "img" && node instanceof HTMLImageElement) {
            const entityConfig = {};
            entityConfig.src = node.getAttribute
              ? node.getAttribute("src") || node.src
              : node.src;
            entityConfig.alt = node.alt;
            entityConfig.height = node.style.height;
            entityConfig.width = node.style.width;
            if (node.style.float) {
              entityConfig.alignment = node.style.float;
            } else {
              if (node.style.textAlign) {
                entityConfig.alignment = node.style.textAlign;
              }
            }
            return {
              type: "IMAGE",
              mutability: "MUTABLE",
              data: entityConfig,
            };
          }
        });
        contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks,
          contentBlock.entityMap
        );
      } else {
        newContent =
          htmlToDraft(`<h5 style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 24px;font-family: Noto Sans TC", sans-serif;"><strong>經營理念</strong></span></h5>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">- 專業 - 法拍專業能力夠讓客戶放心</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">- 負責 - 工作態度積極進取，盡心負責任</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">- 誠信 - 誠實可靠有根據不欺騙、不亂說</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">- 服務 -以客為尊服務至上，永遠的朋友</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">- 熱忱 - 熱忱服務客戶感受深，真正有信任</span></p>
      <h5 style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 24px;font-family: Noto Sans TC", sans-serif;"><strong>企業願景</strong></span></h5>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">1.法拍業界TOP1</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">2.公司上市、股利共享</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">3.全國各地成立服務據點</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">4.服務業前100大</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">5.每個員工都有屬於自己的房子</span></p>
      <h5 style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 24px;font-family: Noto Sans TC", sans-serif;"><strong>光榮紀錄</strong></span></h5>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">首創全國法拍業界法拍屋「四大保證、六大保固」客戶安心尊榮專案之業者。</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">首創全國法拍業界法拍屋進階式專業武功祕笈『轟天大法』以客戶服務品質提昇為導向之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">首創法拍教育研究院、法規研究室、實習輔導中心、『將法院拍賣全套實務有系統傳授』並輔導其創業致富門路之業界。</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">首創法拍行銷、點交專業分離制度，有效提昇服務品質、合法交屋效率、強化專業素質之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家通過ISO9001國際品質管理與品質標準保證認證之法拍業界（SGS Taiwan Ltd.）！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家通過ISO9001認證後，於隔年ISO檢測標準流程與品質榮獲『零缺失』！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家發行法拍專業報紙『法拍生活報』全彩版媒體之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家發行精美全系列『法拍屋教學DVD』法拍致富入門、法拍實戰策略、法拍屋月入百萬行銷技巧、法拍業務教育訓練全系列教材、 法拍創業致富要訣、、、等全套DVD之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家以『講師』身分受邀至『地政士公會』講解法拍實務並創下多年來聽講之代書人數破紀錄之業界權威！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家以『講師』身分(內政部核可講師資格)受邀至『地政從業工會』為不動產經紀人講解法拍實務之業界權威！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家發行全國第一本法拍屋、金拍屋、銀拍屋系列叢書，連續榮獲金石堂、博客來網路書店法律類暢銷書第一名！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家Super 台灣聯播網 FM98.5 電台、好事聯播網FM90.3電台主動採訪報導 的業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家受邀於台中廣播FM100.7電台錄製『世紀名人錄』節目之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家受邀於好事聯播網FM90.3電台錄製『與成功有約』節目之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家以『法拍屋專家』身分受邀於謝震武主持『中天電視台』、于美人主持『TVBS電視台』主講法拍屋之業界權威！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家受邀至全國最大晶圓廠『台積電(TSMC)』講習法拍屋實務之法拍業界權威！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲中國時報以『富門法拍 專業技術領先群倫』為報導之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲career就業情報以『富門 法拍界的領導品牌』為報導之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲台灣時報以『交易零糾紛創口碑』為報導之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲工商時報以『富門具品牌 市場佔有率高為法拍屋領導品牌』為報導之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲大記元時報以『改變法拍屋歷史 對自己和上天負責造福弱勢購屋族』為報導之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家受邀至全國最大有聲書平台『台苯轉投資之簡單移動科技(台北101大樓)』錄製『法拍屋有聲書』並至文化大學做專題演講之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國唯一獲得 法院民事執行處 法官庭長、律師公會理事長推薦專書的法拍權威！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家建請內政部而做出『代標』規範之法拍實務業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家建請內政部而做出『代點』規範之法拍實務業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家建請內政部而做出『代交』規範之法拍實務業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">造福國內眾多法拍代標業者、法拍點交業者、購屋者、原屋主，有效提升不動產交易品質，使其更符合公平正義，並保障消費者、原屋主與 承租人權益。</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家接受群健、新唐人電視台及創業搶鮮誌、就業情報、中時、大紀元、工商時報等電視、報章媒體現場採訪之法拍業界權威！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家擁有『100多本以上』法拍專業叢書與教育訓練書籍之法拍實務業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創造出企業寶寶『富門先生』與企業吉祥動物『富門活力豹』之法拍業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家有企業系列歌曲《富門之歌》《我心狂熱》《活了五千歲》《追求理想》《瀟灑一生》《金銀島》等數十首企業歌曲之法拍業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家實施『交屋安全保障制度』，以『無法交屋原價買回』安全保障機制之法拍業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家實施法拍業務人員『考試制度』與『晉升制度』，重視客戶交易安全與提升服務品質之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家施行法拍業務人員『業務作業流程查檢表』與法拍點交專業人員『點交作業流程查檢表』SOP標準化作業之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家全部單位採行『品質稽核制度』，導入企業360度回饋、目標設定、KPI關鍵稽核指標、自我評量系統等電腦化系統之法拍業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家製作一系列買法拍屋與被拍賣之「法拍屋權益保障安全交易說明手冊」，贈閱買屋者、原屋主與承租人之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家提供『法拍收費標準表』將法拍各項收費方式公開透明化使消費者交易更有保障之業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家導入CIS、Know-How、ISO、SOP制度化開放法拍屋創業、加盟、兼職創新制度之法拍業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家電視CF形象廣告；公車、電台、馬路旗幟、多處定點、各大報、各優質雜誌形象廣告等全面起動之法拍業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家製作研發買屋『法拍屋大亨』遊戲軟體，增進買屋樂趣並同時開發出全國法拍物件、客戶與內部管理系統之法拍業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家於世貿中心參與創業加盟大展促使法拍業邁向更制度化之法拍業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家擁有代書、不動產經紀人、律師、理財專員，深研法拍屋實務與點交之專業權威經營顧問團隊！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創下各級人員均有專屬網站開站系統的房地產業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家可看全省3D街道影像、房屋實景之房地產業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創新研發出無論客戶數多寡1秒即可找出客戶所需物件之房地產業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家98年7月創下法拍屋加盟店正式突破50家歷史紀錄的房地產加盟總部！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創新研發出法拍屋物件1秒即可全部上架至專屬網站之房地產業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創下『房仲業、法拍業、代書業』歷史紀錄，榮獲YAHOO知識+房地產分類『最高等級知識長』之房地產業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家創下房地產業界歷史紀錄，第1榮獲YAHOO知識+房地產與投資2大分類助人王第1名之房地產業界！</span></p>
      <p style="text-align:start;"><span style="color: rgba(0,0,0,0.87);background-color: rgb(255,255,255);font-size: 1rem;font-family: Noto Sans TC", sans-serif;">全國第一家榮獲工商時報邀請講解『法拍屋進階班』之房地產業界！</span>&nbsp;</p>
      `);
        contentState = ContentState.createFromBlockArray(
          newContent.contentBlocks,
          newContent.entityMap
        );
      }
      setValue("editorState", EditorState.createWithContent(contentState));
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  const [saveAboutUs, { loading: saveAboutUsLoading }] = useMutation(
    SAVE_ABOUTUS,
    {
      onCompleted({ saveAboutUs }) {
        if (saveAboutUs) return Alert.notice(`儲存成功`);
        else return Alert.notice(`儲存失敗`);
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );

  function _save(data) {
    const content = draftToHtml(
      convertToRaw(data.editorState.getCurrentContent())
    ).replace(
      /<div style="text-align:none;"><img/g,
      '<div style="text-align:center;"><img'
    );

    console.log(content);
    saveAboutUs({
      variables: {
        id,
        content,
      },
    });
  }

  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <LoadingModal loading={saveAboutUsLoading} />
        <CardContent>
          <Grid container spacing={1} justify="center">
            <Grid item>
              <Text type="h4">關於我們</Text>
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <Grid item xs={12} sm={12}>
            <Controller
              name="editorState"
              control={control}
              // rules={{
              //   required: "請填入網頁標題",
              // }}
              render={({ field, fieldState: { error } }) => (
                // <DraftWysiwyg onChange={field.onChange} />
                <DraftWysiwyg
                  editorState={editorState}
                  onChange={field.onChange}
                />
              )}
            />
          </Grid>
        </CardContent>
        <Divider />
        <CardActions>
          <Grid container spacing={1} justify="center">
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onPress={handleSubmit(_save)}
              >
                儲存
              </Button>
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
